<h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
  <span>Zuletzt besucht</span>
</h6>

<div *ngFor="let obj of lastVisited">
  <a [href]="obj.url" (click)="goTo(obj.url, $event)">{{ obj.title }}</a>
</div>
